var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24h24V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231815",
    d: "M18.001 11h-9.32l4.057-4.318a.998.998 0 00-.045-1.412 1.002 1.002 0 00-1.414.045L5 12l6.279 6.684a1 1 0 101.459-1.367l-4.057-4.319h9.32a.999.999 0 100-1.998"
  }))));
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E %3Cg fill='none' fill-rule='evenodd'%3E %3Cg%3E %3Cpath d='M0 24L24 24 24 0 0 0z'/%3E %3Cpath fill='%23231815' d='M18.001 11h-9.32l4.057-4.318c.378-.403.358-1.035-.045-1.412-.402-.377-1.035-.357-1.414.045L5 12l6.279 6.684c.198.21.463.316.73.316.245 0 .491-.09.684-.27.403-.378.423-1.01.045-1.413l-4.057-4.319h9.32c.552 0 1-.446 1-.998 0-.553-.448-1-1-1'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgIcBack as ReactComponent };